import React from "react";

export const ReferalsInviteIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8061 11.638C18.1247 10.945 17.2241 10.523 16.2681 10.4339C17.0934 9.68558 17.614 8.60531 17.614 7.39856C17.614 5.14096 15.7989 3.31152 13.5585 3.31152C11.4187 3.31152 9.66671 4.982 9.51465 7.09907C11.4183 7.92904 12.7541 9.84103 12.7541 12.0609C12.7541 12.8715 12.5711 13.6637 12.2309 14.3826C12.721 14.6408 13.1729 14.9745 13.5667 15.375C14.5767 16.4 15.1505 17.8171 15.1396 19.2618L15.1388 19.2912L15.1379 19.3163L15.1022 20H19.9599L20 14.5855C20.0082 13.481 19.5791 12.4218 18.8061 11.638Z"
        fill="#C6B7FF"
      />
      <path
        d="M10.1015 15.097C10.9263 14.3492 11.4488 13.2685 11.4488 12.0617C11.4488 9.80369 9.63272 7.97382 7.39275 7.97382C5.15233 7.97382 3.33674 9.80369 3.33674 12.0617C3.33674 13.2663 3.85697 14.3461 4.68046 15.0944C2.57163 15.2591 0.905921 17.0191 0.890671 19.1863L0.850586 20H7.01717H13.7937L13.8338 19.2473C13.8417 18.1433 13.4121 17.0841 12.6395 16.3003C11.9572 15.6069 11.0571 15.1862 10.1015 15.097Z"
        fill="#C6B7FF"
      />
      <path
        d="M2.61599 4.91612V6.43466C2.61599 7.0635 3.12316 7.57421 3.74753 7.57421C4.37277 7.57421 4.87906 7.0635 4.87906 6.43466V4.91612H6.384C7.00837 4.91612 7.5151 4.40497 7.5151 3.77569C7.5151 3.14685 7.00837 2.63569 6.384 2.63569H4.87906V1.13956C4.87906 0.510276 4.37277 0 3.74753 0C3.12316 0 2.61599 0.510276 2.61599 1.13956V2.63525H1.1311C0.505857 2.63525 0 3.14641 0 3.77525C0 4.40453 0.505857 4.91569 1.1311 4.91569L2.61599 4.91612Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};
